let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

const footer_slider = new Swiper(".footer-icon-with-text_swiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
  spaceBetween: 20,
  loop: false,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    425: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    480: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    769: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    801: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
    991: {
      slidesPerView: 4,
      slidesPerGroup: 1,
    },
  },
});


if (document.body.clientWidth < 991) {
  // const service_icon_swiper = new Swiper(".service-icon-blocks", {
  //   loop: true,
  //   speed: 1000,
  //   scrollbar: {
  //     el: ".service-icon-blocks .swiper-pagination",
  //     hide: false,
  //     draggable: true
  //   },
  //   autoplay: {
  //     delay: 2500,
  //     disableOnInteraction: false,
  //   },
  //   pagination: {
  //     el: ".service-icon-blocks .swiper-pagination",
  //     type: "progressbar",
  //   },
  //   navigation: {
  //     nextEl: ".service-icon-blocks .swiper-button-next",
  //     prevEl: ".service-icon-blocks .swiper-button-prev",
  //   },
  //   keyboard: {
  //     enabled: true,
  //     onlyInViewport: true,
  //   },
  //   effect: "slide",
  //   breakpoints: {
  //     0: { slidesPerView: 1, spaceBetween: 0, centeredSlides: true },
  //     400: { slidesPerView: 1, spaceBetween: 0, centeredSlides: true },
  //     575: { slidesPerView: 2, spaceBetween: 10 },
  //     768: { slidesPerView: 2, spaceBetween: 10 },
  //     990: { slidesPerView: 2, spaceBetween: 10 },
  //   },
  // });
}

// If transperent
var transperentElment = document.querySelector(".allow-transparent-header");
var header = document.querySelector(".header-wrapper");
var topbar = document.querySelector(".announce-main-wipper");
if (transperentElment) {
    header.classList.add("allow-transparent-header");
    topbar.classList.add("allow-transparent-header");
}


// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 5);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = '92px';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();


// accordions js start
// function faq_taggol() {
//   const accordions = document.querySelectorAll("[js-acc-item]");
//   const openAccordion = (accordion) => {
//     const content = accordion.querySelector("[js-acc-single-content]");
//     accordion.classList.add("active");
//     content.style.maxHeight = 'max-content';
//   };
  
//   const closeAccordion = (accordion) => {
//     const content = accordion.querySelector("[js-acc-single-content]");
//     accordion.classList.remove("active");
//     if(content){
//       content.style.maxHeight = null;
//     }
//   };
  
//   accordions.forEach((accordion) => {
//     const intro = accordion.querySelector("[js-acc-single-trigger]");
//     const content = accordion.querySelector("[js-acc-single-content]");
//     if(intro){
//         intro.onclick = (e) => {
//           if (content.style.maxHeight) {
//             closeAccordion(accordion);
//           } else {
//             accordions.forEach((accordion) => closeAccordion(accordion));
//             openAccordion(e.target.closest('[js-acc-item]'));
//           }
//         };
//     }
//   });   
// }
// // accordions js end
// (function() {
//   faq_taggol();
// })();

//footer accordian
// accordions js start
function nav_taggol() {
  const accordionss = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    tab_content.style.maxHeight = tab_content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(tab_content){
      tab_content.style.maxHeight = null;
    }
  };

  accordionss.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    if(intro && tab_content){
        intro.onclick = (e) => {
          if (tab_content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordionss.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
nav_taggol();

//cross cell variant change
document.addEventListener("change", function(e) {
  if (e.target.classList.contains("cross-variant-select")) {

    const select = e.target;
    const card = select.closest(".related-product-card");

    const variantId = select.value;
    const price = select.options[select.selectedIndex].dataset.price;

    card.querySelector(".product-variant-id").value = variantId;

    const priceBox = card.querySelector(".rel-price");
    if(priceBox){
      priceBox.innerHTML = price;
    }
  }
});

//cart drawer upcell quantity
document.addEventListener("click", function(e){
  const plusBtn = e.target.closest(".plus");
  const minusBtn = e.target.closest(".minus");
  if(plusBtn){
    const input = plusBtn.closest(".quantity").querySelector(".quantity__input");
    input.value = parseInt(input.value) + 1;
  }
  if(minusBtn){
    const input = minusBtn.closest(".quantity").querySelector(".quantity__input");
    if(input.value > 1){
      input.value = parseInt(input.value) - 1;
    }
  }
});

//filter menu hover 
document.addEventListener("DOMContentLoaded", function () {
  const detailsList = document.querySelectorAll(".custom-category-menu details");

  detailsList.forEach((detail) => {
    detail.addEventListener("toggle", function () {
      if (this.open) {
        detailsList.forEach((el) => {
          if (el !== this) {
            el.removeAttribute("open");
          }
        });
      }
    });
  });
});

//product tab
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      buttons.forEach(b => b.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});

//size chart popup
document.addEventListener("click", function(e){

  const popup = document.getElementById("size-guide-popup");
  const popupContent = document.querySelector(".size-guide-content");

  if (!popup) return;
  if(e.target.classList.contains("size-guide-btn")){
    popup.classList.add("active");
    document.body.classList.add('size-guide-popup-open');
  }
  if(
    e.target.classList.contains("size-guide-close") ||
    e.target.classList.contains("size-guide-overlay")
  ){
    popup.classList.remove("active");
    document.body.classList.remove('size-guide-popup-open');
  }
  if (
    popup.classList.contains("active") &&
    popupContent &&
    !popupContent.contains(e.target) &&
    !e.target.classList.contains("size-guide-btn")
  ) {
    popup.classList.remove("active");
    document.body.classList.remove('size-guide-popup-open');
  }

});

const swiper = new Swiper(".testimonial-box-wrapper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: false,
  speed: 1000,
  navigation: {
    nextEl: ".testimonial-custom-block .swiper-button-next",
    prevEl: ".testimonial-custom-block .swiper-button-prev",
  },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
});

// header menu close icon trigger
document.querySelectorAll('.hender-close').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.header__icon.header__icon--menu').forEach(function(menuIcon) {
            menuIcon.click();
        });
    });
});

if (document.body.clientWidth < 750) {
    const newsletter = document.querySelector(".footer-block--newsletter");
    const brand_information = document.querySelector(".footer-block--brand_information");

    const copyright__content_logo = document.querySelector(".copyright__content_logo");
    const footer__blocks = document.querySelector(".footer__blocks-wrapper");

    if (newsletter && brand_information) {
        brand_information.after(newsletter);
    }

    if (copyright__content_logo && footer__blocks) {
        footer__blocks.before(copyright__content_logo);
    }
}

//sorting code
document.addEventListener('change', function(e) {
  if (e.target.matches('#SortBy')) {
    const url = new URL(window.location.href);

    // remove old sort_by
    url.searchParams.delete('sort_by');

    // add new one
    url.searchParams.set('sort_by', e.target.value);

    window.location.href = url.toString();
  }
});